/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CommentMentionNotificationAction } from './CommentMentionNotificationAction';
import {
    CommentMentionNotificationActionFromJSON,
    CommentMentionNotificationActionFromJSONTyped,
    CommentMentionNotificationActionToJSON,
} from './CommentMentionNotificationAction';

/**
 * 
 * @export
 * @interface CommentMentionNotification
 */
export interface CommentMentionNotification {
    /**
     * 
     * @type {string}
     * @memberof CommentMentionNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof CommentMentionNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommentMentionNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof CommentMentionNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<CommentMentionNotificationAction>}
     * @memberof CommentMentionNotification
     */
    actions: Array<CommentMentionNotificationAction>;
}

/**
 * Check if a given object implements the CommentMentionNotification interface.
 */
export function instanceOfCommentMentionNotification(value: object): value is CommentMentionNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function CommentMentionNotificationFromJSON(json: any): CommentMentionNotification {
    return CommentMentionNotificationFromJSONTyped(json, false);
}

export function CommentMentionNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentMentionNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(CommentMentionNotificationActionFromJSON)),
    };
}

export function CommentMentionNotificationToJSON(value?: CommentMentionNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(CommentMentionNotificationActionToJSON)),
    };
}

